import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import './base-sorting-modal.component.scss';
import { namespace } from 'vuex-class';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { DisplayTask, GetTaskResponse } from '@/tsort/model/response/get-task-response.model';
import { ScanMode } from '@/common/enum/scan-mode.enum';
import { ValidationProvider } from 'vee-validate';
import { ChuteModeType } from '@/tsort/enum/chute-mode-type.enum';
import { WorkTypeSorting } from '@/tsort/enum/work-type-sorting.enum';
import CommonUtil from '@/common/utils/common.util';
import SwipeButton from '@/common/components/swipe-button/swipe-button';
import { ScanConfirmPacket } from '@/common/model/scan-confirm-packet.model';
import { SortingTable } from '@/tsort/model/sorting-table';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import SortingUtils from '@/common/utils/sorting.util';
import { isNumber } from 'lodash';
import AppConstants from '@/common/constants/app.constants';

// ストアモジュール
const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
@Component({})
export default class BaseSortingModal extends Vue {
  @Prop() title!: string;
  @Prop() isShow!: boolean;
  @Prop() chuteModeType!: number;
  @Prop() scanCodePattern!: string;
  @Prop() targetTask!: GetTaskResponse;
  @Prop() inputQuantityStore!: number[];
  @Prop() modeType!: ScanMode;
  @Prop() fieldNameScanCode!: string;
  @Prop() sortingType!: string;
  @Prop() refSortingModal!: string;
  @Prop() isShowWarningMsgModal!: boolean;

  inputQuantity = 0;
  currentTaskListIndex = 0;
  isOnFieldClick = false;
  targetTaskList = [] as DisplayTask[];
  isShowData = false;
  onClickChangeCurrentPositionInput = false;
  isSelectingText = false;
  isZero = false;
  inputCount = 0;
  scanCodeInput = '';
  isScanningError = false;
  isScanning = false;
  isFirstScan = true;
  maxInputQuantity = 0;
  dataScanInput!: HTMLInputElement;
  dataSortingTable: Array<SortingTable> = [];
  isManualChangeInputQty = false;
  $refs!: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
  };

  /*Sort store*/
  @SortStore.Getter
  wesNo!: string;

  @SortStore.Getter
  lastChuteNo!: string;

  @SortStore.Getter
  workTypeSorting!: WorkTypeSorting;

  @SortStore.Getter
  workInstruction!: WorkInstruction;

  // ------------------------- Vueウォッチャーを開始する -------------------
  @Watch('isShow')
  isShowWatcher(): void {
    this.isShowData = this.isShow;
    this.isScanning = false;
    this.currentTaskListIndex = 0;
    if (!this.isShowData) {
      this.closeModal();
      return;
    }
    // モーダルを表示するときに最初のスキャンを設定する
    this.isFirstScan = true;
    this.updateInputQuantity();
    if (SortingUtils.isMultiSorting) {
      this.isZero = false;
      this.onClickChangeCurrentPositionInput = false;
      // Reset index when intiate modal
      if (this.isChuteModeOn) {
        this.currentTaskListIndex = 0;
      }
    } else {
      setTimeout(() => {
        this.isZero = false;
        this.focusField(true);
        this.onClickChangeCurrentPositionInput = false;
      }, 100);
    }
  }

  @Watch('targetTask')
  fetchTargetTaskList(): void {
    // Check scanning status
    this.isManualChangeInputQty = false;
    if (this.targetTaskList === this.targetTask?.displayTasks) this.isScanningError = true;
    else this.isScanningError = false;
    this.onClickChangeCurrentPositionInput = false;
    const currentTargetTask = this.targetTaskList[this.currentTaskListIndex];

    // シュート番号を切り捨てる
    if (SortingUtils.isHandSorting) {
      // シュート番号は切り捨てられたシュートブランチ番号でした
      const chuteNoCurrentIndexTruncatedChuteBranchNo = currentTargetTask?.chuteNo?.substring(
        0,
        currentTargetTask?.chuteNo.length - currentTargetTask?.chuteBranchNo?.toString().length
      );

      if (this.targetTaskList.length !== this.targetTask.displayTasks.length) {
        for (let idx = 0; idx < this.targetTaskList.length; idx++) {
          // インデックス要素を最初に取得する類似のシュート番号切り捨てられたシュートブランチ番号
          if (this.targetTaskList[idx]?.chuteNo?.indexOf(chuteNoCurrentIndexTruncatedChuteBranchNo) != -1) {
            this.currentTaskListIndex = idx;
            break;
          }
        }
      }
    }

    // Passing data from props to internal data
    this.targetTaskList = this.targetTask.displayTasks;

    // As some chutes with item's remainingQty = 0 were removed from targetTaskList, we need update the value of current chute index
    // The value of current chute index remains unchanged if the chute element at current index is available, otherwise its values will be the first index
    this.currentTaskListIndex = this.targetTaskList[this.currentTaskListIndex] ? this.currentTaskListIndex : 0;
    // Update field values
    this.resetField();
    if (!this.isScanningError && this.isScanning) this.inputCount = 0;
    this.updateInputQuantity();
    this.$emit('changeTaskList');
    this.updateDataSortingTable();
  }

  @Watch('currentTaskListIndex')
  updateDataSortingTable(): void {
    if (SortingUtils.isHandSorting && this.isOneHundredPercentScan) {
      this.dataSortingTable = [
        {
          columnName: '残数',
          numberOfTasks: this.targetTaskList[this.currentTaskListIndex || 0]?.remainingQty,
          orderUnit: this.targetTask.orderUnit
        }
      ];
    } else if (SortingUtils.isNoWorkInstruction) {
      this.dataSortingTable = [
        {
          columnName: '実績数',
          numberOfTasks: this.targetTaskList[this.currentTaskListIndex || 0]?.actualQty,
          orderUnit: this.targetTask.orderUnit
        }
      ];
    } else {
      this.dataSortingTable = [
        {
          columnName: '予定数',
          numberOfTasks: this.targetTaskList[this.currentTaskListIndex || 0]?.plannedQty,
          orderUnit: this.targetTask.orderUnit
        },
        {
          columnName: '実績数',
          numberOfTasks: this.targetTaskList[this.currentTaskListIndex || 0]?.actualQty,
          orderUnit: this.targetTask.orderUnit
        },
        {
          columnName: '残数',
          numberOfTasks: this.targetTaskList[this.currentTaskListIndex || 0]?.remainingQty,
          orderUnit: this.targetTask.orderUnit
        }
      ];
    }
  }

  @Watch('scanCodeInput')
  scanInputCount(): void {
    if (this.scanCodeInput === this.scanCodePattern) {
      this.$refs.swipeButton?.resetToStateToStart();
    } else {
      (this.$refs.inputSortingModalRef as InstanceType<typeof ValidationProvider>)?.setErrors(['商品が違います']);
      this.$refs.swipeButton?.handleError(false);
    }
  }

  @Emit()
  acceptBtn(): ScanConfirmPacket {
    this.isScanning = true;
    this.isManualChangeInputQty = true;
    (this.$refs.validationProvider as InstanceType<typeof ValidationProvider>)?.reset();
    const scanConfirmPacket = {
      inputQuantity: this.inputQuantity.toString(),
      chuteNo: this.targetTaskList[this.currentTaskListIndex]?.chuteNo,
      remainingQty: 0,
      maxInputQuantity: this.maxInputQuantity
    } as ScanConfirmPacket;

    if (this.isRepresentativeScan) {
      return scanConfirmPacket;
    }
    scanConfirmPacket.remainingQty = this.targetTaskList[this.currentTaskListIndex]?.remainingQty;
    scanConfirmPacket.maxInputQuantity = this.maxInputQuantity;

    return scanConfirmPacket;
  }

  @Emit('exitBtn')
  exit(): void {
    // Reset modal status before closing
    this.closeModal();
    this.isScanning = false;
    this.currentTaskListIndex = 0;
    return;
  }
  // ------------------------- Vueウォッチャーを終了 -------------------

  // ------------------------- 送信エリアを開始します -------------------
  handlePressButtonEvent(e: KeyboardEvent): void {
    if (this.isShowWarningMsgModal) {
      e.preventDefault();
      return;
    }
    if (e.key == 'Enter' && this.isShow) {
      if (this.isRepresentativeScan) {
        this.acceptBtn();
      } else {
        const focusedElement = document.activeElement;
        if (focusedElement?.id === 'accept-btn') {
          return;
        }
        this.swipeToScanCode();
      }
    } else if (e.key == 'Escape' && this.isShow) {
      this.exit();
    } else if (this.isShow && (e.key == 'Backspace' || isNumber(parseInt(e.key)))) {
      this.isManualChangeInputQty = true;
    }
  }

  /**
   * Handle Scan swipe btn for all scan mode
   */
  async swipeToScanCode() {
    const resultValid = await (this.$refs.inputSortingModalRef as InstanceType<typeof ValidationProvider>)?.validate();
    if (!resultValid?.valid) {
      CommonUtil.playErrorSound();
      (this.$refs.swipeButton as SwipeButton)?.handleError(false);
      this.focusField(true);
      return;
    }
    if (this.scanCodeInput === this.scanCodePattern) {
      this.inputQuantity = ++this.inputCount;

      // Lock swipe button to scan
      this.$refs.swipeButton?.handleSuccess(false);
      CommonUtil.playSuccessSound();
      if (this.isEnough()) {
        this.scanCodeInput = '投入数に達しました';
      } else {
        this.scanCodeInput = '';
        (this.$refs.inputSortingModalRef as InstanceType<typeof ValidationProvider>)?.reset();
        this.focusField();
      }
    }
  }

  closeModal(): void {
    this.$bvModal.hide(this.refSortingModal);
  }
  // ------------------------- 送信エリア終了 -------------------

  // ------------------------- シュートエリア変更開始 -------------------

  backTaskList(): void {
    if (this.currentTaskListIndex == 0) return;
    this.currentTaskListIndex -= 1;
    // Update field values
    this.resetField();
    this.updateInputQuantity();
    this.isOnFieldClick = false;
    this.isSelectingText = false;
    this.$emit('changeTaskList');
  }

  nextTaskList(): void {
    if (this.currentTaskListIndex == this.targetTaskList.length - 1) return;
    this.currentTaskListIndex += 1;
    // Update field values
    this.resetField();
    this.updateInputQuantity();
    this.isOnFieldClick = false;
    this.isSelectingText = false;
    this.$emit('changeTaskList');
  }

  // ------------------------- 撮影エリア変更終了 -------------------

  // ------------------------- 数字キーボードと入力領域を開始します -------------------
  resetField(): void {
    if (this.isRepresentativeScan) {
      return;
    }
    if (
      (!this.isScanningError && this.isScanning && !this.isFirstScan) ||
      (this.isScanningError && !this.isFirstScan)
    ) {
      this.inputCount = 0;
    } else this.inputCount = 1;

    this.scanCodeInput = '';
  }

  focusField(select = false): void {
    this.$nextTick(() => {
      if (this.isRepresentativeScan) {
        if (select) {
          (this.$refs['inputQuantityRef'] as HTMLInputElement)?.select();
          this.isOnFieldClick = true;
          this.isSelectingText = true;
        } else (this.$refs['inputQuantityRef'] as HTMLInputElement)?.focus();
      } else {
        if (select) {
          (this.$refs['scanCodeRef'] as HTMLInputElement)?.select();
          this.isOnFieldClick = true;
          this.isSelectingText = true;
        } else {
          (this.$refs['scanCodeRef'] as HTMLInputElement)?.focus();
          this.isOnFieldClick = true;
          this.isSelectingText = false;
        }
      }
    });
  }

  onFieldsClickEvent(): void {
    if (!this.isOnFieldClick) {
      (this.$refs[`inputQuantityRef`] as HTMLInputElement)?.select();
      this.isSelectingText = true;
    }
    if (this.isOnFieldClick) {
      this.isSelectingText = false;
    }
    this.isOnFieldClick = true;
  }

  deleteInputField(): void {
    // REPRESENTATIVE SCAN
    if (this.isRepresentativeScan) {
      this.inputQuantity = 0;
      this.isManualChangeInputQty = true;
    } else {
      // 100% SCAN
      if (this.isEnough()) return;
      this.scanCodeInput = '';
    }
  }

  @Watch('isShowWarningMsgModal')
  checkToFocusFieldAgain(): void {
    if (!this.isShowWarningMsgModal) {
      setTimeout(() => {
        this.focusField(true);
      }, 200);
    }
  }

  outFocus(): void {
    if (!this.scanCodeInput) {
      (this.$refs.inputSortingModalRef as InstanceType<typeof ValidationProvider>)?.reset();
    }
  }

  isEnough(): boolean {
    if (SortingUtils.isMultiSorting) {
      if (SortingUtils.isNoWorkInstruction) {
        return (
          this.inputQuantity >= (!this.targetTask.inputQty ? AppConstants.QUANTITY_MAX_VALUE : this.targetTask.inputQty)
        );
      } else if (this.isChuteModeOff) {
        return this.inputQuantity >= this.targetTask.inputQty;
      }
    }
    return this.inputQuantity >= (this.targetTaskList[this.currentTaskListIndex]?.remainingQty || 0);
  }

  getCurrentPossitionInput(): number {
    let inputRef = 'scanCodeRef';
    if (this.isRepresentativeScan) {
      inputRef = 'inputQuantityRef';
    }
    const position = (this.$refs[inputRef] as HTMLInputElement)?.selectionStart ?? -9999;
    return position;
  }

  updateCurrentPositionInput(position: number): void {
    this.$nextTick(() => {
      if (this.isRepresentativeScan)
        (this.$refs['inputQuantityRef'] as HTMLInputElement)?.setSelectionRange(position, position);
      else (this.$refs['scanCodeRef'] as HTMLInputElement)?.setSelectionRange(position, position);
    });
  }

  checkDifferentInputQuantity(): boolean {
    if (this.inputQuantityStore.length < 1 || this.isManualChangeInputQty) return false;
    return !this.inputQuantityStore.includes(this.inputQuantity);
  }

  /**
   * 代表スキャンのシュートインおよびシュートオフモードで現在の投入量が最大投入量制限を超えているかどうかを確認します。
   * @returns 入力数量が最大許容数量を超える場合は「true」を返し、それ以外の場合は「false」を返します。
   */
  isExceedMaxQuantityInChute(): boolean {
    return this.inputQuantity > this.maxInputQuantity;
  }

  /**
   * スキャンコードの入力が最大数量を超えているかどうかを確認します。
   * @returns {boolean} 最大数量を超えている場合は true、それ以外の場合は false を返します。
   */
  isScanCodeInputExceedMaxQuantityDefault(): boolean {
    return this.inputQuantity > AppConstants.QUANTITY_MAX_VALUE;
  }

  /**
   * 入力数量が制限を超えるかどうかを確認します。
   * @returns {boolean} 入力数量が制限を超える場合はtrue、それ以外の場合はfalse
   */
  isInputQtyExceedLimits(): boolean {
    // 入力された数量が、現在のタスクリストの残り数量を超えているかどうかを確認します
    const isInputQtyExceedRemainingQty =
      this.inputQuantity > this.targetTaskList[this.currentTaskListIndex]?.remainingQty;
    // 入力された数量が残り数量を超えているかどうかをチェックし、並列マルチソートかつシュートモードがONであるか、または手動ソートである場合にtrueを返します
    return (
      isInputQtyExceedRemainingQty &&
      ((SortingUtils.isParallelMultiSorting && this.chuteModeType === ChuteModeType.ON) || SortingUtils.isHandSorting)
    );
  }

  // eslint-disable-next-line
  onFieldBlurEvent(event: any): void {
    const htmlElement = event.relatedTarget as HTMLInputElement;
    if (!htmlElement?.classList.contains('calc-button')) {
      this.isOnFieldClick = false;
      this.isSelectingText = false;
    }
  }

  updateInputQuantity(): void {
    if (this.isShow) {
      /* REPRESENTATIVE SCAN */
      if (this.isRepresentativeScan) {
        if ((SortingUtils.isMultiSorting && this.isChuteModeOff) || SortingUtils.isNoWorkInstruction) {
          if (this.targetTask.inputQty) {
            this.inputQuantity = this.targetTask.inputQty;
            this.maxInputQuantity = Math.min(this.inputQuantity, AppConstants.QUANTITY_MAX_VALUE);
          } else {
            this.inputQuantity = 1;
            this.maxInputQuantity = AppConstants.QUANTITY_MAX_VALUE;
          }
        } else {
          this.inputQuantity = this.targetTaskList[this.currentTaskListIndex]
            ? this.targetTaskList[this.currentTaskListIndex]?.remainingQty
            : 0;
          this.maxInputQuantity = Math.min(this.inputQuantity, AppConstants.QUANTITY_MAX_VALUE);
        }
        this.updateCurrentPositionInput(this.inputQuantity.toString().length);
        setTimeout(() => {
          this.focusField(true);
        }, 50);
      } else {
        /* 100% SCAN */
        this.inputQuantity = this.inputCount;
        if ((SortingUtils.isMultiSorting && this.isChuteModeOff) || SortingUtils.isNoWorkInstruction) {
          this.maxInputQuantity = this.targetTask ? this.targetTask.inputQty : 0;
        }
        if (this.isEnough()) this.scanCodeInput = '投入数に達しました';
        this.$refs.swipeButton?.handleError(false);
        setTimeout(() => {
          this.focusField();
        }, 50);
        this.updateCurrentPositionInput(this.scanCodeInput.toString().length);
      }
    }
  }

  onClickNumericCalcButton(value: string): void {
    const inputQuantityConverted = this.inputQuantity.toString();
    const currentpositionInput = this.getCurrentPossitionInput();
    /* REPRESENTATIVE SCAN */
    if (this.isRepresentativeScan) {
      if (isNumber(parseInt(value))) {
        this.isManualChangeInputQty = true;
      }
      // Fields are selecting, SELECTING, hence the currentPositionInput == 0
      if (this.isOnFieldClick && this.isSelectingText && currentpositionInput === 0) {
        this.inputQuantity = parseInt(value);
        this.isOnFieldClick = false;
        this.isSelectingText = false;
      }
      // Fields are selecting, NOT SELECTING, hence the currentPositionInput == 0
      else if (this.isOnFieldClick && !this.isSelectingText && currentpositionInput === 0) {
        this.inputQuantity = parseInt(
          [
            inputQuantityConverted.slice(0, currentpositionInput),
            value,
            inputQuantityConverted.slice(currentpositionInput)
          ].join('')
        );
        this.isOnFieldClick = false;
      }
      // Fields are not selecting, NOT SELECTING
      else {
        if (this.getCurrentPossitionInput() === 0) {
          // Users don't change currentPositionInput, append str to the end of the input quantity
          if (!this.isZero && !this.onClickChangeCurrentPositionInput) {
            this.inputQuantity = parseInt(inputQuantityConverted + value);
            this.focusField();
            this.updateCurrentPositionInput(this.inputQuantity.toString().length);
            return;
          } else {
            this.inputQuantity = parseInt(
              [
                inputQuantityConverted.slice(0, currentpositionInput),
                value,
                inputQuantityConverted.slice(currentpositionInput)
              ].join('')
            );
            this.onClickChangeCurrentPositionInput = false;
          }
          // Default case
        } else {
          this.inputQuantity = parseInt(
            [
              inputQuantityConverted.slice(0, currentpositionInput),
              value,
              inputQuantityConverted.slice(currentpositionInput)
            ].join('')
          );
          this.isOnFieldClick = false;
        }
      }
      // After processing => update current position input
      const updatedPositionInput = currentpositionInput + value.length;
      this.focusField();
      this.updateCurrentPositionInput(updatedPositionInput);
    } else {
      /* 100% SCAN */
      if (this.isEnough()) return;
      const inputScanCodeConverted = this.scanCodeInput.toString();
      if (this.isOnFieldClick && this.isSelectingText && currentpositionInput === 0) {
        this.scanCodeInput = value;
        this.isOnFieldClick = false;
        this.isSelectingText = false;
      } else {
        this.scanCodeInput = [
          inputScanCodeConverted.slice(0, currentpositionInput),
          value,
          inputScanCodeConverted.slice(currentpositionInput)
        ].join('');
        this.isOnFieldClick = false;
      }
      const updatedPositionInput = currentpositionInput + value.length;
      this.focusField();
      this.updateCurrentPositionInput(updatedPositionInput);
    }
  }

  increaseCurrentPositionInputField(): void {
    const positionInput = this.getCurrentPossitionInput();
    if (positionInput === 0 && this.isSelectingText) {
      this.focusField();
      this.updateCurrentPositionInput(positionInput - 1);
      this.onClickChangeCurrentPositionInput = true;
      this.isOnFieldClick = false;
      this.isSelectingText = false;
      return;
    }
    this.focusField();
    this.updateCurrentPositionInput(positionInput + 1);
    this.onClickChangeCurrentPositionInput = true;
    this.isOnFieldClick = false;
    this.isSelectingText = false;
  }

  decreaseCurrentPositionInputField(): void {
    const currentPositionInput = this.getCurrentPossitionInput();
    this.focusField();
    this.updateCurrentPositionInput(currentPositionInput - 1);
    this.onClickChangeCurrentPositionInput = true;
    this.isOnFieldClick = false;
    this.isSelectingText = false;
  }

  deleteInputQuantity() {
    const currentPositionInput = this.getCurrentPossitionInput();
    const inputQuantityConverted = this.inputQuantity.toString();
    /* REPRESENTATIVE SCAN */
    if (this.isRepresentativeScan) {
      this.isManualChangeInputQty = true;
      // Fields are clicking, SELECTING, hence the currentPositionInput == 0
      if (this.isOnFieldClick && this.isSelectingText && currentPositionInput == 0) {
        this.isOnFieldClick = false;
        this.isSelectingText = false;
        this.inputQuantity = 0;
        this.focusField();
        this.updateCurrentPositionInput(1);
        return;
      }
      // Fields are clicking ,NOT SELECTING, hence the currentPositionInput == 0
      else if (this.isOnFieldClick && !this.isSelectingText && currentPositionInput == 0) {
        this.focusField();
        this.updateCurrentPositionInput(inputQuantityConverted.length);
        this.isOnFieldClick = false;
        this.isZero = false;
      }
      // Fields are not clicking, NOT SELECTING
      else {
        // Delete characters from the end
        if (inputQuantityConverted.length > 1) {
          if (currentPositionInput === 0 && !this.onClickChangeCurrentPositionInput && !this.isZero) {
            this.inputQuantity = parseInt(inputQuantityConverted.substring(0, inputQuantityConverted.length - 1));
            // Update position Input after delete
            this.focusField();
            this.updateCurrentPositionInput(this.inputQuantity.toString().length);
          }
          // Delete characters depend on the currentPositionInput
          else if (currentPositionInput > 0) {
            this.inputQuantity = parseInt(
              [
                inputQuantityConverted.slice(0, currentPositionInput - 1),
                inputQuantityConverted.slice(currentPositionInput, this.inputQuantity.toString().length)
              ].join('')
            );
            this.focusField();
            setTimeout(() => {
              this.updateCurrentPositionInput(currentPositionInput - 1);
            }, 50);
            this.isZero = currentPositionInput - 1 === 0 ? true : false;
            this.isOnFieldClick = false;
            this.onClickChangeCurrentPositionInput = false;
          }
          // The current position is at the begin without any conditions above
          else {
            this.focusField();
            return;
          }
        } else {
          if (currentPositionInput !== 0) {
            this.inputQuantity = 0;
            this.focusField();
            this.updateCurrentPositionInput(1);
          }
        }
      }
    } else {
      /* 100% SCAN */
      if (this.isEnough()) return;
      const inputConverted = this.scanCodeInput.toString();
      //フィールドがクリックされ、選択されています
      if (this.isOnFieldClick && this.isSelectingText && currentPositionInput == 0) {
        this.isOnFieldClick = false;
        this.isSelectingText = false;
        this.scanCodeInput = '';
        this.focusField();
        this.updateCurrentPositionInput(0);
        return;
      }
      // フィールドがクリックされていますが、選択されていません
      else if (this.isOnFieldClick && !this.isSelectingText && currentPositionInput == 0 && inputConverted) {
        this.focusField();
        this.updateCurrentPositionInput(inputConverted.length);
        this.isOnFieldClick = false;
      }
      // 現在のカーソルがフィールドの先頭にある場合
      if (currentPositionInput === 0 && this.scanCodeInput.length > 0) {
        setTimeout(() => {
          this.focusField();
        }, 50);
        return;
      }
      if (inputConverted && inputConverted.length > 1) {
        this.scanCodeInput = [
          inputConverted.slice(0, currentPositionInput - 1),
          inputConverted.slice(currentPositionInput, this.scanCodeInput.toString().length)
        ].join('');
        // Update position Input after delete
        this.focusField();
        this.updateCurrentPositionInput(currentPositionInput - 1);
      } else {
        this.scanCodeInput = '';
        this.focusField();
        this.updateCurrentPositionInput(0);
      }
    }
  }
  // ------------------------- 数字キーボードと入力領域を終了します -------------------

  // ------------------------- 開始条件メソッド -------------------
  /**
   * スキャンモードが代表スキャンであるかどうかをチェックします。
   * @returns {boolean} 代表スキャンであればtrue、そうでなければfalseを返します。
   */
  get isRepresentativeScan(): boolean {
    return this.modeType === ScanMode.REPRESENTATIVE_SCAN;
  }

  /**
   * スキャンモードが100％スキャンであるかどうかをチェックします。
   * @returns {boolean} 100％スキャンであればtrue、そうでなければfalseを返します。
   */
  get isOneHundredPercentScan(): boolean {
    return this.modeType === ScanMode.ONE_HUNDRED_PERCENT_SCAN;
  }

  /**
   * シュートモードがオンであるかどうかをチェックします。
   * @returns {boolean} シュートモードがオンであればtrue、そうでなければfalseを返します。
   */
  get isChuteModeOn(): boolean {
    return this.chuteModeType === ChuteModeType.ON;
  }

  /**
   * シュートモードがオフであるかどうかをチェックします。
   * @returns {boolean} シュートモードがオフであればtrue、そうでなければfalseを返します。
   */
  get isChuteModeOff(): boolean {
    return this.chuteModeType === ChuteModeType.OFF;
  }
  // ------------------------- 終わり条件メソッド -------------------

  // ------------------------- HTMLエリアを開始します -------------------
  get getInputScopedSlot() {
    return {
      default: ({ errors }: { errors: string[] }) => {
        return (
          <div v-frag>
            <b-input-group>
              <input
                ref="inputQuantityRef"
                v-model={this.inputQuantity}
                type="text"
                // readonly
                class={{
                  changeQuantity: true,
                  'border-danger bg-danger-outline':
                    errors.length > 0 || (!this.checkDifferentInputQuantity() && this.isExceedMaxQuantityInChute())
                }}
                onClick={() => this.onFieldsClickEvent()}
                onBlur={(e: Event) => this.onFieldBlurEvent(e)}
                onInput={() => (this.isOnFieldClick = false)}
              />
              <b-input-group-prepend>
                <span
                  class="icon-clean-data-button-svg align-cancel-icon"
                  onClick={() => {
                    this.deleteInputField();
                  }}
                >
                  <span class="d-none">Clean</span>
                </span>
              </b-input-group-prepend>
            </b-input-group>
            {!this.checkDifferentInputQuantity() && this.isExceedMaxQuantityInChute() ? (
              <p class="validate-error-msg">
                {this.isInputQtyExceedLimits()
                  ? '残数以下にしてください。'
                  : `投入数の上限${this.maxInputQuantity}以下にしてください。`}
              </p>
            ) : /* Initial input value change display */
            SortingUtils.isParallelSorting && this.checkDifferentInputQuantity() && errors.length == 0 ? (
              <p class="validate-error-msg">
                <span class="material-icons md-red">report</span> 数量が変わりました。
              </p>
            ) : (
              <div>
                {errors?.map((error) => {
                  return <p class="validate-error-msg">{error}&nbsp;</p>;
                })}
              </div>
            )}
          </div>
        );
      }
    };
  }

  get getScanCodeInputScopeSlot() {
    return {
      default: ({ errors }: { errors: string[] }) => {
        if (this.isEnough()) errors = [];
        return (
          <div>
            <b-input-group>
              <input
                ref="scanCodeRef"
                v-model={this.scanCodeInput}
                type="text"
                disabled={this.isEnough()}
                onClick={() => this.onFieldsClickEvent()}
                onBlur={() => this.outFocus()}
                class={{
                  changeQuantity: true,
                  'border-danger bg-danger-outline':
                    errors.length > 0 || this.isScanCodeInputExceedMaxQuantityDefault(),
                  'is-enough disabled': this.isEnough()
                }}
                on-input={(_e: Event) => {
                  this.scanInputCount();
                }}
              />
              {this.isEnough() ? (
                ''
              ) : (
                <b-input-group-prepend>
                  <span
                    class="icon-clean-data-button-svg align-cancel-icon"
                    onClick={() => {
                      this.deleteInputField();
                    }}
                  >
                    <span class="d-none">Clean</span>
                  </span>
                </b-input-group-prepend>
              )}
            </b-input-group>
            {this.isScanCodeInputExceedMaxQuantityDefault() && errors.length === 0 ? (
              <p class="validate-error-msg">投入数の上限{AppConstants.QUANTITY_MAX_VALUE}以下にしてください。</p>
            ) : this.isEnough() ? (
              <span class="warning">{SortingUtils.isHandSorting ? '完了してください。' : '発進してください。'}</span>
            ) : (
              <span class="warning">{errors}&nbsp;</span>
            )}
          </div>
        );
      }
    };
  }
  // ------------------------- HTMLエリアを終了する -------------------
}
